import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

export const additionalFormFieldsListener = () => {
    const additionalFormFields = [
        ...document.querySelectorAll('.js-additional-form-fields-controller'),
    ].filter((el) => !el.dataset.additionalFormFieldsInitialized);

    additionalFormFields.forEach((additionalFormField) => {
        additionalFormField.addEventListener('change', (e) => {
            // e.preventDefault();

            const additionalFormFieldsContainer = document.querySelector(
                additionalFormField.dataset.containerSelector
            );

            if (additionalFormFieldsContainer) {
                if (e.target.checked) {
                    toggleAllInputsInContainer(additionalFormFieldsContainer, true);
                    additionalFormFieldsContainer.classList.remove('d-none');
                } else {
                    toggleAllInputsInContainer(additionalFormFieldsContainer, false);
                    additionalFormFieldsContainer.classList.add('d-none');
                }
            }
        });
    });
};
